import type { CustomerUserCategory } from "shared";

export const PERMISSION_OPTIONS = [
  { label: "Privileged", value: "privileged" as const },
  { label: "Standard", value: "standard" as const },
];

export const PERMISSION_TOOLTIP =
  "Privileged users can see every ticket raised for their company. standard users only see their own.";

/**
 * Used until GET /configuration/user-categories ships (MAU-2). Ids are the tier
 * keys so a payload built from the fallback stays readable in the network tab.
 * OPEN: the confirmed listing endpoint's response shape is unverified — if it
 * does not carry `tier` + `is_default`, this fallback is what the UI keeps using.
 */
// Promoted to `shared/features/customer-user-category` (2026-09-02) — the ticket
// table needs the same tier ladder. Re-exported so this module's imports are
// unchanged.
export { FALLBACK_CATEGORIES } from "shared/features/customer-user-category";
